var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "viber_1_",
    "data-name": "viber (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5193",
    "data-name": "Path 5193",
    d: "M28.5,38H9.5A9.5,9.5,0,0,1,0,28.5V9.5A9.5,9.5,0,0,1,9.5,0h19A9.5,9.5,0,0,1,38,9.5v19A9.5,9.5,0,0,1,28.5,38",
    transform: "translate(0 0)",
    fill: "#785afa",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5194",
    "data-name": "Path 5194",
    d: "M17.737,11.055H28.38A5.415,5.415,0,0,0,33.694,5.81,5.467,5.467,0,0,0,28.924.028C28.74.018,28.563,0,28.38,0H9.46A9.648,9.648,0,0,0,0,9.828V29.48C0,19.3,7.941,11.055,17.737,11.055",
    transform: "translate(0 0)",
    fill: "#9678ff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5195",
    "data-name": "Path 5195",
    d: "M41.827,25.827a9.827,9.827,0,1,0,9.827,9.827V16a9.826,9.826,0,0,1-9.828,9.827",
    transform: "translate(-13.653 -7.48)",
    fill: "#5f41e1",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873",
    transform: "translate(5.677 5.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5196",
    "data-name": "Path 5196",
    d: "M34.684,24.991c-.706,5.516-4.876,5.862-5.644,6.1a24.157,24.157,0,0,1-7.186.592S19,34.505,18.12,35.37a.491.491,0,0,1-.411.163c-.154-.036-.2-.212-.2-.469.006-.366.025-4.037.025-4.037-5.564-1.5-5.239-7.118-5.177-10.063s.633-5.356,2.334-6.978c3.046-2.674,9.329-2.274,9.329-2.274,5.306.022,7.849,1.568,8.439,2.087,1.953,1.622,2.954,5.5,2.223,11.191Zm-.762-12.568c-.694-.622-3.513-2.6-9.784-2.627,0,0-7.395-.432-11,2.769-2.008,1.943-2.715,4.786-2.788,8.311S9.682,31.008,16.26,32.8v2.733c0,.7.215,1.726,1.253,1.726a2.681,2.681,0,0,0,1.867-.985l2.794-2.608a27.842,27.842,0,0,0,7.6-.658c.909-.285,6.05-.923,6.885-7.528.86-6.809-.418-11.116-2.733-13.057Z",
    transform: "translate(-10.305 -9.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5197",
    "data-name": "Path 5197",
    d: "M31.579,18a6.754,6.754,0,0,1,6.756,6.756.632.632,0,0,1-.178.434.615.615,0,0,1-1.05-.434,5.532,5.532,0,0,0-5.527-5.527h-.055a.615.615,0,0,1-.614-.614.606.606,0,0,1,.178-.434.615.615,0,0,1,.436-.18Z",
    transform: "translate(-18.255 -13.167)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5198",
    "data-name": "Path 5198",
    d: "M31.579,22a4.3,4.3,0,0,1,4.3,4.3.615.615,0,0,1-1.05.434.632.632,0,0,1-.178-.434,3.071,3.071,0,0,0-3.07-3.071h-.056a.615.615,0,0,1-.436-.18.606.606,0,0,1-.178-.434A.615.615,0,0,1,31.524,22Z",
    transform: "translate(-18.255 -14.782)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5199",
    "data-name": "Path 5199",
    d: "M34.328,31.67A.944.944,0,0,0,34.2,30.5a15.414,15.414,0,0,0-2.432-1.756,1.079,1.079,0,0,0-1.37.19l-.5.62c-.626.774-2.543-.386-3.452-1.336-.952-.914-2.113-2.828-1.339-3.456l.62-.492a1.083,1.083,0,0,0,.19-1.373,14.812,14.812,0,0,0-1.757-2.431A.941.941,0,0,0,23,20.336a5.525,5.525,0,0,0-1.277,1.037,1.622,1.622,0,0,0-.436,1.667,18.2,18.2,0,0,0,3.943,6.4,18.256,18.256,0,0,0,6.4,3.94,1.621,1.621,0,0,0,1.671-.433,7.614,7.614,0,0,0,1.032-1.279Z",
    transform: "translate(-14.512 -14.178)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViber);
export default __webpack_public_path__ + "static/media/viber.2f961d00267ecc7321c42d070f1abae9.svg";
export { ForwardRef as ReactComponent };